import { unifyUrlFormat } from '@luna/router';

import type { Tracker } from '../model/Tracker';
import { TrackingEvent } from '../model/TrackingEvent';
import type { AjaxErrorDetail } from './AjaxErrorDetail';

export class AjaxErrorTrackService {
    tracker: Tracker;

    constructor(tracker: Tracker) {
        this.tracker = tracker;
    }

    track(type: string, name: string, errorDetail: AjaxErrorDetail): void {
        this.tracker.track(this.createTrackingEvent(type, name, errorDetail));
    }

    createTrackingEvent(
        type: string,
        name: string,
        ajaxErrorDetail: AjaxErrorDetail,
    ): TrackingEvent<any> {
        return new TrackingEvent(type, name, unifyUrlFormat(window.location.hash), ajaxErrorDetail);
    }
}
